module.exports = __webpack_public_path__ + "static/media/summer_loop.d74f9693.mp3";